import { mapState } from 'vuex';
import podcastslist from "./list/index.vue";

export default {
    name: 'podcasts',
    props: {
    },

    data : function(){

        return {
            loading : true,
            tokens : []
        }

    },

    components : {
        podcastslist
    },

    created()  {
        this.load()
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        token : function(){
            if (this.tokens.length){
                return this.tokens[0].token
            }
        }
    }),

    methods : {
        load : function(){

            this.loading = false
          
        },
    },
}